import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";

const STATS = [
  { n: 10, l: "Website services we offer" },
  { n: 8, l: "Industries we design for" },
  { n: 6, l: "Steps from idea to launch" },
  { n: 3, l: "Flexible website packages" },
];

const Counter = ({ to }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  const [val, setVal] = useState(to);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, to, { duration: 1.6, ease: [0.16, 1, 0.3, 1], onUpdate: (v) => setVal(Math.round(v)) });
    return () => c.stop();
  }, [inView, to]);
  return <span ref={ref}>{String(val).padStart(2, "0")}</span>;
};

export const Stats = () => (
  <section data-testid="stats-section" className="border-y border-white/5 bg-navy/40">
    <div className="mx-auto grid max-w-7xl grid-cols-2 px-5 sm:px-8 lg:grid-cols-4">
      {STATS.map((s, i) => (
        <div key={s.l} data-testid={`stat-${i}`} className={`py-12 sm:py-16 ${i % 2 ? "pl-6 sm:pl-10" : ""} ${i > 0 ? "lg:border-l lg:border-white/5 lg:pl-10" : ""}`}>
          <p className="font-display text-5xl font-semibold text-gold-grad sm:text-6xl"><Counter to={s.n} /></p>
          <p className="mt-3 text-sm text-slate-300">{s.l}</p>
        </div>
      ))}
    </div>
  </section>
);
